import * as UserActions from "./userActions";

export default UserActions;



// WEBPACK FOOTER //
// ./src/actions/UserActions/index.js